import React from 'react'
import { useTranslation } from 'react-i18next'

function GameFeatures() {
  const { t } = useTranslation()

  return (
    <div className="game-features">
      <div className="game-features__wrapper">
        <div className="game-features__circles">
          <div className="game-features__circle">
            <div className="game-features__text">{t('landing.game_overview.circle_1.text_1')}</div>
            <div className="game-features__blue-text">
              {t('landing.game_overview.circle_1.text_2')}
            </div>
            <div className="game-features__text">{t('landing.game_overview.circle_1.text_3')}</div>
          </div>

          <div className="game-features__circle">
            <div className="game-features__blue-text">
              {t('landing.game_overview.circle_3.text_1')}
            </div>
            <div className="game-features__text">{t('landing.game_overview.circle_3.text_2')}</div>

            <div className="game-features__blue-text">
              {t('landing.game_overview.circle_3.text_3')}
            </div>
            <div className="game-features__text">
                {t('landing.game_overview.circle_3.text_4')}
            </div>
          </div>
        </div>
        <div className="game-features__circles">
          <div className="game-features__circle">
            <div className="game-features__text">{t('landing.game_overview.circle_2.text_1')}</div>
            <div className="game-features__blue-text">
              {t('landing.game_overview.circle_2.text_2')}
            </div>
            <div className="game-features__text">{t('landing.game_overview.circle_2.text_3')}</div>
          </div>

          <div className="game-features__circle">
            <div className="game-features__text">
              <div className="game-features__blue-text">
                {t('landing.game_overview.circle_4.text_1')}
              </div>
              {t('landing.game_overview.circle_4.text_2')}
              <div className="game-features__blue-text">
                {t('landing.game_overview.circle_4.text_3')}
              </div>
            </div>
            <div className="game-features__text">{t('landing.game_overview.circle_4.text_4')}</div>
            <div className="game-features__text">{t('landing.game_overview.circle_4.text_5')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GameFeatures
